import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MigajasCategorias from "@components/MigajasCategorias";
import axios from '@fetch/axios';
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";

const ListaSubcategorias = () => {
  const navigate = useNavigate();
  const { categoria } = useParams();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const { lang,currency } = useContext(LanguageCurrencyContext);

  useEffect(() => {
    const fetchCategory = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/categories/detail?uri=${categoria}`  + `&lang=`+lang+ `&currency=`+currency);
        setCategory(response.data);
      } catch (error) {
        console.error('Error fetching category details', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategory();
  }, [categoria,lang,currency]);

  const LoadingCard = () => {
    const buttonPlaceholder = {
      width: "20%",
      height: 80,
      backgroundColor: "rgba(233, 227, 227, 0.65)",
      borderRadius: 6,
    };

    return (
      <>
        {Array.from({ length: 4 }).map((_, idx) => (
          <article
            key={idx}
            className="ImageButtonBG"
            style={{
              backgroundImage: "none",
              backgroundColor: "rgba(0, 0, 0, 0.44)",
              minHeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 16,
            }}
          >
            <div style={buttonPlaceholder}></div>
          </article>
        ))}
      </>
    );
  };

  const CategoryItem = (item, image,index) => {
    return (
      <article
        key={index}
        className="ImageButtonBG"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div>
          <div
            className="ButtonContent ButtonDarkMini"
            onClick={() => navigate(`/category/${categoria}/${item.uri}`)}
          >
            {item.name}
          </div>
        </div>
      </article>
    );
  };

  return (
    <>
      <MigajasCategorias nivel1={category ? category.name : "Loading..."} />
      <section className="CategoryBox">
        {loading ? LoadingCard() : category?.subcategories?.map((subcategory,index) => (
          CategoryItem(subcategory, subcategory.desktop_image,index)
        ))}
      </section>
    </>
  );
};

export default ListaSubcategorias;
